import { writable } from "svelte/store";

export const isAdmin = writable(Boolean(parseInt(sessionStorage.getItem("_admin"))) || 0);
export const authToken = writable(sessionStorage.getItem("_token") || "");
export const adminName = writable(sessionStorage.getItem("_name") || "");
export const surveyFilters = writable(sessionStorage.getItem("_survey") || "");

isAdmin.subscribe(val => {
  if (val) sessionStorage.setItem("_admin", 1);
  else {
    sessionStorage.setItem("_admin", 0);
    authToken.set("");
    adminName.set("");
  }
});

adminName.subscribe(val => {
  sessionStorage.setItem("_name", val);
});

authToken.subscribe(val => {
  sessionStorage.setItem("_token", val);
});

surveyFilters.subscribe(val => {
  sessionStorage.setItem("_survey", val);
});